export const getProjectManagementBasePath = (role = 'admin') =>
  `/${role === 'admin' ? 'admin' : 'employee'}/project-management`;

export const getProjectManagementPaths = (role = 'admin') => {
  const base = getProjectManagementBasePath(role);
  return {
    projects: `${base}/projects`,
    projectView: (id = ':id') => `${base}/projects/${id}`,
    featureView: (id = ':id', featureId = ':featureId') =>
      `${base}/projects/${id}/features/${featureId}`,
    tasks: `${base}/tasks`,
    taskView: (taskId = ':taskId') => `${base}/tasks/${taskId}`,
    summaryReport: `${base}/summary-report`,
  };
};

export const PROJECT_MANAGEMENT_BASE_PATH = getProjectManagementBasePath('admin');
export const PROJECT_MANAGEMENT_PATHS = getProjectManagementPaths('admin');

export const getProjectManagementMenuGroup = (role = 'admin') => {
  const paths = getProjectManagementPaths(role);
  return {
    type: 'group',
    key: 'project-management',
    label: 'Project Management',
    icon: '🧩',
    children: [
      { path: paths.projects, label: 'Projects', icon: '📁' },
      { path: paths.tasks, label: 'Tasks', icon: '🗂️' },
      { path: paths.summaryReport, label: 'Summary Report', icon: '📊' },
    ],
  };
};

export const PROJECT_MANAGEMENT_MENU_GROUP = getProjectManagementMenuGroup('admin');
